import { tickerItems } from "@/mocks/home";

export default function NoticeTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-10 max-w-[1440px] items-center px-4 md:px-6">
        <div className="flex shrink-0 items-center gap-2 pr-4 md:pr-6">
          <span className="flex h-5 w-5 items-center justify-center">
            <span className="h-2 w-2 rounded-full bg-accent-500 animate-pulseDot" />
          </span>
          <span className="text-[11px] font-label font-medium tracking-wide text-accent-400 md:text-xs">
            运营播报
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 text-[11px] text-background-100/90 md:text-xs"
              >
                <i className="ri-flashlight-line text-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden shrink-0 items-center gap-4 border-l border-background-50/15 pl-6 lg:flex">
          <span className="text-[11px] text-background-100/70">值班编辑在线</span>
          <span className="text-[11px] font-medium text-accent-400">24h 接收投稿</span>
        </div>
      </div>
    </div>
  );
}